interface RightArrowProps {
  fill?: string;
}

export default function RightArrow({ fill }: RightArrowProps) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Automated migration to Biome
    <svg
      width='23'
      height='19'
      viewBox='0 0 23 19'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22.3906 9.45703C22.3906 9.23828 22.3008 9.04297 22.1211 8.87109L14.2344 0.972656C14.0625 0.808593 13.8711 0.726562 13.6602 0.726562C13.4414 0.726562 13.2578 0.80078 13.1094 0.949218C12.9609 1.08984 12.8867 1.26562 12.8867 1.47656C12.8867 1.58594 12.9063 1.69141 12.9453 1.79297C12.9766 1.89453 13.0273 1.97656 13.0977 2.03906L16.625 5.60156L20.6211 9.30469L20.8086 8.83594L17.3516 8.67187L1.40234 8.67187C1.17578 8.67187 0.992188 8.74609 0.851563 8.89453C0.703126 9.04297 0.628907 9.23047 0.628907 9.45703C0.628907 9.68359 0.703126 9.87109 0.851563 10.0195C0.992188 10.168 1.17578 10.2422 1.40234 10.2422L17.3516 10.2422L20.8086 10.0781L20.6211 9.59766L16.625 13.3125L13.0977 16.875C13.0273 16.9453 12.9766 17.0273 12.9453 17.1211C12.9063 17.2227 12.8867 17.3281 12.8867 17.4375C12.8867 17.6484 12.9609 17.8242 13.1094 17.9648C13.2578 18.1133 13.4414 18.1875 13.6602 18.1875C13.7695 18.1875 13.875 18.1641 13.9766 18.1172C14.0781 18.0781 14.1836 18 14.293 17.8828L22.1211 10.043C22.3008 9.87891 22.3906 9.68359 22.3906 9.45703Z'
        fill={fill ? fill : '#202645'}
      />
    </svg>
  );
}
